import styled from 'styled-components';
import vars from '../lib/styled';

export default styled.div`
    display: flex;
    flex-direction: row; 
    flex-wrap: wrap;
`;

export const Half = styled.div`
    width: 50%;

    @media(max-width: ${vars.breakpoint.tablet}){
        width: 100%;
    }
`;

export const TwoThirds = styled.div`
    width: 66%;

    @media(max-width: ${vars.breakpoint.tablet}){
        width: 100%;
    }
`;

export const Third = styled.div`
    width: 33%;

    @media(max-width: ${vars.breakpoint.tablet}){
        width: 50%;
    }

    @media(max-width: ${vars.breakpoint.phone}){
        width: 100%;
    }
`;
